<template>
  <div class="sirui-table">
    <vxe-toolbar :style="{ display: buttonList.length == 0 ? 'none' : 'block' }" :data="data">
      <template v-slot:buttons>
        <vxe-button
          v-for="(x, i) in buttonList"
          type="primary"
          :icon="x.buttonStyle"
          :style="
            'background-color:' +
            (x.buttonName == '删除' || x.buttonName == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)') +
            ';border:1px solid ' +
            (x.buttonName == '删除' || x.buttonName == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)')
          "
          :key="i"
          @click="chooseClick(x.buttonUrl)"
          >{{ x.buttonName }}</vxe-button
        >
      </template>
    </vxe-toolbar>

    <vxe-table
      :data="data"
      resizable
      :auto-resize="true"
      border
      column-key
      size="mini"
      show-overflow
      show-header-overflow
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :row-id="rowKey"
      min-width="120"
      :height="height"
      :max-height="maxHeight"
      :fit="true"
      :loading="loading"
      :tree-config="{ children: 'children', expandAll: true }"
      :checkbox-config="{ labelField: labelField }"
      @select-change="handleSelectionChange"
    >
      >
      <slot></slot>
    </vxe-table>
  </div>
</template>
<script>
  import Sortable from 'sortablejs';

  export default {
    name: 'TreeTable',
    props: {
      height: {
        type: String,
        default: () => '',
      },
      maxHeight: {
        type: String,
        default: () => '',
      },
      //按钮列表
      buttonList: {
        type: Array,
        default: () => [],
      },
      //table数据
      data: {
        type: Array,
        default: () => [],
      },
      //row-id
      rowKey: {
        type: String,
        default: () => 'id',
      },
      labelField: {
        type: String,
        default: () => '',
      },
      //设置选中
      checkRowKeys: {
        type: Array,
        default: () => [],
      },
      //是否添加loading效果
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        sortable: {},
        multipleSelection: [], // 表格被选中的行数据
      };
    },
    beforeDestroy() {
      if (this.sortable) {
        this.sortable.destroy();
      }
    },
    mounted() {
      this.columnDrop();
    },
    methods: {
      columnDrop() {
        this.$nextTick(() => {
          let xTable = this.$refs.xTable;
          this.sortable = Sortable.create(
            xTable.$el.querySelector('.body--wrapper>.vxe-table--header .vxe-header--row'),
            {
              handle: '.vxe-header--column:not(.col--fixed)',
              onEnd: ({ item, newIndex, oldIndex }) => {
                let { fullColumn, tableColumn } = xTable.getTableColumn();
                let targetThElem = item;
                let wrapperElem = targetThElem.parentNode;
                let newColumn = fullColumn[newIndex];
                if (newColumn.fixed) {
                  // 错误的移动
                  if (newIndex > oldIndex) {
                    wrapperElem.insertBefore(targetThElem, wrapperElem.children[oldIndex]);
                  } else {
                    wrapperElem.insertBefore(wrapperElem.children[oldIndex], targetThElem);
                  }
                  return this.$XModal.message({
                    message: '固定列不允许拖动！',
                    status: 'error',
                  });
                }
                // 转换真实索引
                let oldColumnIndex = xTable.getColumnIndex(tableColumn[oldIndex]);
                let newColumnIndex = xTable.getColumnIndex(tableColumn[newIndex]);
                // 移动到目标列
                let currRow = fullColumn.splice(oldColumnIndex, 1)[0];
                fullColumn.splice(newColumnIndex, 0, currRow);
                xTable.loadColumn(fullColumn);
              },
            }
          );
        });
      },
      //排序
      sortChangeEvent({ column, property, order }) {
        this.$emit('sortChangeEvent', { column, property, order });
      },
      //抛出勾选框表格选中事件
      handleSelectionChange(val) {
        this.$emit('handleSelectionChange', val.selection);
        this.multipleSelection = val.selection;
      },
      //获取当前高亮行的数据
      getCurrentRecord() {
        return this.$refs.xTable.getCurrentRecord();
      },
      //设置选中
      toggleRowSelection() {
        this.$refs.xTable.setAllSelection(true);
      },
      //重新刷新表格
      reloadTable(data) {
        this.$refs.xTable.reloadData(data);
      },
      //点击按钮调用父页面方法
      chooseClick(buttonUrl) {
        this.$emit('chooseClick', buttonUrl, this.multipleSelection);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .sirui-table {
    padding-top: 0px;
    .vxe-toolbar {
      padding: 0px 0px 10px 0px;
      .vxe-button {
        height: 30px;
        line-height: 30px;
        min-width: 80px;
        border-radius: 3px;
        font-size: 12px;
      }
    }
  }
  .el-pagination {
    text-align: right;
    padding-top: 10px;
    margin-bottom: 8px;
  }
</style>
